import { render, staticRenderFns } from "./Card.vue?vue&type=template&id=25b833e6"
import script from "./Card.vue?vue&type=script&lang=js"
export * from "./Card.vue?vue&type=script&lang=js"
import style0 from "./styles/card.scss?vue&type=style&index=0&prod&lang=scss&external"
import style1 from "./styles/card-status.scss?vue&type=style&index=1&prod&lang=scss&external"
import style2 from "./styles/game-name.scss?vue&type=style&index=2&prod&lang=scss&external"
import style3 from "./styles/card-message.scss?vue&type=style&index=3&prod&lang=scss&external"
import style4 from "./Card.vue?vue&type=style&index=4&id=25b833e6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports